type Props = {
  text: string;
};

const Copyright = ({ text }: Props) => {
  const year = new Date().getFullYear();
  const updatedText = text.replace('2026', year.toString());

  return (
    <div className='justify-center` flex items-center text-[13px] text-zinc-100'>
      <span className='md:text-center'>{updatedText}</span>
    </div>
  );
};

export default Copyright;
